import { compose, composeU } from '@yandex-int/hr-components/lib/compose';

import {
    Button as BaseButton,
    withBaseline,
    withSizeL,
    withSizeS,
    withTypeLink,
    withViewBrand,
    withViewContrast,
    withViewGhost,
    withViewMedia,
    withViewPrimary,
    withViewSecondary,
    withWidthMax,
} from '@yandex-int/hr-components/Button';

import { withViewLegal } from "./Button_view_legal";
import { withViewNeuro } from "./Button_view_neuro";

export const Button = compose(
    composeU(
        withViewBrand,
        withViewPrimary,
        withViewSecondary,
        withViewGhost,
        withViewContrast,
        withViewMedia,
        withViewLegal,
        withViewNeuro
    ),
    composeU(withTypeLink),
    composeU(withSizeL, withSizeS),
    composeU(withBaseline, withWidthMax),
)(BaseButton);
